import React from "react";

const RecipientsModal = ({
  isVisible,
  handlerModelCancelForSave,
  selectedLanguage,
  recipientToEmails,
  recipientCcEmails,
  recipientBccEmails,
}) => {
  if (!isVisible) return null;

  return (
     <div className="modalCus documentversion-history" id="myModal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="card-body pt-1">
                <div
                  className="mb-2 mt-3 justify-content-between d-flex"
                  style={{ borderBottom: "2px solid #918d8d4d" }}>
                  <h4 htmlFor="">
                    <p className="fw-bold" style={{ color: "#bc272e" }}>
                      {selectedLanguage.LstLanguageCodes.UI_Recipients}
                    </p>
                  </h4>
                  <button
                    type="button"
                    className="btn btn-outline-danger modalclose download"
                    onClick={(e) => handlerModelCancelForSave()}>
                    <span className="material-icons font-20">
                      highlight_off
                    </span>
                  </button>
                </div>
                <div className="saveSettingPopupTextBox table-responsive">
                  {recipientToEmails != "" && (
                    <>
                      <div className="ToEmailsBG">
                        <span className="EmailsFont">
                          {selectedLanguage.LstLanguageCodes.UI_To}:
                        </span>
                      </div>
                      <label className="textBoxSave" style={{ width: "100%" }}>
                        {recipientToEmails}
                      </label>
                    </>
                  )}
                  {recipientCcEmails != "" && (
                    <>
                      <div className="ToEmailsBG">
                        <span className="EmailsFont">
                          {selectedLanguage.LstLanguageCodes.UI_CC}:
                        </span>
                      </div>
                      <div>
                        <label
                          className="textBoxSave"
                          style={{ width: "100%", marginBottom: "7px" }}
                          readOnly>
                          {recipientCcEmails}
                        </label>
                      </div>
                    </>
                  )}
                  {recipientBccEmails != "" && (
                    <>
                      <div className="ToEmailsBG">
                        <span className="EmailsFont">
                          {selectedLanguage.LstLanguageCodes.UI_BCC}:
                        </span>
                      </div>
                      <div>
                        <label
                          className="textBoxSave"
                          style={{ width: "100%" }}
                          readOnly>
                          {recipientBccEmails}
                        </label>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
  );
};

export default RecipientsModal;
